import {
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
} from "@mui/material";

import { TableLoadingSkeleton } from "components/DataGrid/components/TableLoadingSkeleton";
import { NoRowOverlay } from "components/DataGrid/components/NoRowOverlay";

import {
  CustomTableRow,
  EXPAND_DETAILS_COLUMN,
} from "./components/CustomTableRow";

export { EXPAND_DETAILS_COLUMN };
export const CustomTable = ({
  columns,
  rows,
  expandableRowComponent,
  loading,
  getRowId,
  ...rest
}) => {
  return (
    <Table {...rest}>
      <TableHead>
        <TableRow>
          {columns.map((headCell) => (
            <TableCell
              key={headCell.field}
              align={headCell.alignRight ? "right" : "left"}
            >
              {headCell.headerName}
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {loading && (
          <TableRow>
            <TableCell colSpan={columns.length}>
              <TableLoadingSkeleton />
            </TableCell>
          </TableRow>
        )}
        {!loading && rows.length === 0 && (
          <TableRow>
            <TableCell colSpan={columns.length}>
              <NoRowOverlay />
            </TableCell>
          </TableRow>
        )}
        {!loading &&
          rows.map((row, index) => {
            return (
              <CustomTableRow
                key={(getRowId?.(row) || row.id) + index}
                columns={columns}
                row={row}
                expandableRowComponent={expandableRowComponent}
              />
            );
          })}
      </TableBody>
    </Table>
  );
};
